// const { createFFmpeg, fetchFile } = (window as any).FFmpeg;
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
let ffmpeg: any = null;
let loggerFn: any;

export interface ILogMessage {
    type: string;
    message: string;
}

export const initFFMPEG = async (
    writeLogFn: (message: ILogMessage) => void
): Promise<boolean> => {
    ffmpeg = createFFmpeg({
        logger: writeLogFn,
        // corePath: 'https://dim0147.github.io/dyl-editor/ffmpeg/ffmpeg-core.js',
        corePath: 'https://unpkg.com/@ffmpeg/core@0.8.5/dist/ffmpeg-core.js',
    });
    await ffmpeg.load();
    loggerFn = writeLogFn;
    return true;
};

export const setLog = (fn: any) => {
    ffmpeg.setLogger((message: any) => {
        fn(message);
    });
};

function fileUrlToArrayBuffer(fileUrl: string): any {
    return fetch(fileUrl)
        .then((res) => res.arrayBuffer())
        .then((buffer) => Buffer.from(buffer));
}

export const mergeVideo = async (
    srcVideo: string | null,
    srcAudio: string | null,
    args: Array<string>
): Promise<Uint8Array> => {
    if (ffmpeg === null) throw new Error('FFMPEG not load!');

    loggerFn({
        type: 'INFO',
        message:
            'Loading Audio And Video File... (it will take long time depend on the duration of video and audio and your internet connection)',
    });

    if (srcVideo !== null && srcAudio !== null) {
        const result = await Promise.all([
            fileUrlToArrayBuffer(srcVideo),
            fileUrlToArrayBuffer(srcAudio),
        ]);
        ffmpeg.FS('writeFile', 'srcVideo', result[0]);
        ffmpeg.FS('writeFile', 'srcAudio', result[1]);
    } else {
        if (srcVideo !== null)
            // ffmpeg.FS('writeFile', 'srcVideo', await fetchFile(srcVideo));
            ffmpeg.FS(
                'writeFile',
                'srcVideo',
                await fileUrlToArrayBuffer(srcVideo)
            );
        if (srcAudio !== null)
            // ffmpeg.FS('writeFile', 'srcAudio', await fetchFile(srcAudio));
            ffmpeg.FS(
                'writeFile',
                'srcAudio',
                await fileUrlToArrayBuffer(srcAudio)
            );
    }

    loggerFn({
        type: 'INFO',
        message: 'Start Rendering...',
    });
    await ffmpeg.run(...args, 'output.mp4');

    return ffmpeg.FS('readFile', 'output.mp4');
};
